import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ManageBranchService } from "../api/services";
import DatePicker from "react-datepicker";
import axios from "axios";
const TransactionHistory = () => {
  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState("daily"); // daily | monthly
  const [showPickerModal, setShowPickerModal] = useState(false);
  const [superAdmin_id, setsuperAdmin_id] = useState(null);
  const [IsLoading, setIsLoading] = useState(false);

  // Daily
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [filterddailyTransactions, setfilterddailyTransactions] = useState([]);

  // Monthly
  const [selectedMonth, setSelectedMonth] = useState(new Date());
  const [monthlyTransactions, setMonthlyTransactions] = useState([]);

  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  // ---------- Helpers ----------
  const getDateLabel = (date) =>
    date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });

  const formatMonthYear = (date) => {
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${month}-${year}`;
  };

  const formatMonthYearDisplay = (date) => {
    const monthNames = [
      "Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();
    return `${month}-${year}`;
  };

  // ---------- API Fetchers ----------
  const fetchTransactionsForMonth = (userId, date) => {
    const payload = { user_id: userId, month: formatMonthYear(date) };
    setIsLoading(true);
    ManageBranchService.get_user_transactions(payload)
      .then((res) => {
        setMonthlyTransactions(res.data.results || []);
        setIsLoading(false);
      })
      .catch((err) => {
        console.error("Failed to fetch monthly transactions:", err);
        setMonthlyTransactions([]);
        setIsLoading(false);
      });
  };

  const fetchTransactionsForDayWise = (userId, date, currDate) => {
    const payload = { user_id: userId, month: formatMonthYear(date) };
    setIsLoading(true);
    ManageBranchService.get_user_transactions(payload)
      .then((res) => {
        const allTransactions = res.data.results || [];
        const filteredTransactions = allTransactions.filter((tx) => {
          const txDate = new Date(tx.transaction_time);
          return (
            txDate.getFullYear() === currDate.getFullYear() &&
            txDate.getMonth() === currDate.getMonth() &&
            txDate.getDate() === currDate.getDate()
          );
        });
        setfilterddailyTransactions(filteredTransactions);
        setIsLoading(false);
      })
      .catch((err) => {
        console.error("Failed to fetch daily transactions:", err);
        setfilterddailyTransactions([]);
        setIsLoading(false);
      });
  };

  // ---------- Navigation ----------
  const handleDayChange = (direction) => {
    const newDate = new Date(selectedDate);
    newDate.setDate(selectedDate.getDate() + direction);
    setSelectedDate(newDate);
    setCurrentPage(1);
    fetchTransactionsForDayWise(superAdmin_id, newDate, newDate);
  };

  const handleMonthChange = (direction) => {
    const newDate = new Date(selectedMonth);
    newDate.setMonth(selectedMonth.getMonth() + direction);
    setSelectedMonth(newDate);
    setCurrentPage(1);
    fetchTransactionsForMonth(superAdmin_id, newDate);
  };

  // ---------- Init ----------
  useEffect(() => {
    const TokenVal = localStorage.getItem("jwtToken");
    if (!TokenVal) navigate("/");

    const userId = localStorage.getItem("admin_id");
    setsuperAdmin_id(userId);

    fetchTransactionsForMonth(userId, new Date());
    fetchTransactionsForDayWise(userId, new Date(), new Date());
  }, []);

  // ---------- Summary Calculations ----------
  const calculateSummary = (transactions) => {
    let totalSelf = 0;
    let totalAgent = 0;
    let totalAdmin = 0;
    let selfCount = 0;
    let agentCount = 0;
    let adminCount = 0;

    transactions.forEach((t) => {
      const amt = Number(t.amount);
      
      // Count and sum based on transaction_type
      if (t.transaction_type === "SELF") {
        totalSelf += amt;
        selfCount += 1;
      } else if (t.transaction_type === "AGENT") {
        totalAgent += amt;
        agentCount += 1;
      } else if (t.transaction_type === "ADMIN") {
        totalAdmin += amt;
        adminCount += 1;
      }
    });

    // Calculate totals for recharges card
    const totalCredit = totalSelf; // Green - Self transactions (income)
    const totalDebit = totalAgent + totalAdmin; // Red - Agent + Admin transactions (outgoing)

    return { 
      totalSelf, 
      totalAgent,
      totalAdmin,
      totalCredit,
      totalDebit,
      selfCount, 
      agentCount, 
      adminCount,
      totalTransactions: transactions.length,
      totalAmount: totalSelf + totalAgent + totalAdmin
    };
  };

  const dailySummary = calculateSummary(filterddailyTransactions);
  const monthlySummary = calculateSummary(monthlyTransactions);

  // ---------- Pagination ----------
  const transactionsToDisplay =
    activeTab === "daily" ? filterddailyTransactions : monthlyTransactions;

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const paginatedTransactions = transactionsToDisplay.slice(
    indexOfFirstItem,
    indexOfLastItem
  );
  const totalPages = Math.ceil(transactionsToDisplay.length / itemsPerPage);

  // ---------- Date Picker Modal ----------
  const renderDatepickerModal = () =>
    showPickerModal && (
      <div
        className="modal d-block"
        tabIndex="-1"
        style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content rounded">
            <div className="modal-header">
              <h5 className="modal-title fw-bold">
                {activeTab === "daily" ? "Select Date" : "Select Month"}
              </h5>
              <button
                type="button"
                className="btn-close"
                onClick={() => setShowPickerModal(false)}
              ></button>
            </div>
            <div className="modal-body text-center">
              <DatePicker
                selected={activeTab === "daily" ? selectedDate : selectedMonth}
                onChange={(date) => {
                  activeTab === "daily"
                    ? setSelectedDate(date)
                    : setSelectedMonth(date);
                }}
                dateFormat={activeTab === "daily" ? "dd/MM/yyyy" : "MM/yyyy"}
                inline
                showMonthYearPicker={activeTab === "monthly"}
              />
            </div>
            <div className="modal-footer">
              <button
                className="btn btn-secondary"
                onClick={() => setShowPickerModal(false)}
              >
                Cancel
              </button>
              <button
                className="btn btn-primary"
                onClick={() => {
                  if (activeTab === "daily") {
                    fetchTransactionsForDayWise(
                      superAdmin_id,
                      selectedDate,
                      selectedDate
                    );
                  } else {
                    fetchTransactionsForMonth(superAdmin_id, selectedMonth);
                  }
                  setShowPickerModal(false);
                  setCurrentPage(1); // Reset to first page when changing date
                }}
              >
                OK
              </button>
            </div>
          </div>
        </div>
      </div>
    );

  // ---------- Render ----------
  return (
    <div className="container mt-3">
      {/* Loader */}
      <div className="loader" style={IsLoading ? {} : { display: "none" }}>
        <div className="lds-spinner">
          {Array.from({ length: 12 }).map((_, i) => (
            <div key={i}></div>
          ))}
        </div>
      </div>
     <button
      className="btn btn-outline-secondary mb-3"
       onClick={() => navigate(-1)}>
        ← Back
    </button>
      {/* Tabs */}
      <div className="d-flex mb-3">
        <button
          className={`flex-fill btn ${
            activeTab === "daily" ? "CommonColor" : "btn-light"
          }`}
          onClick={() => setActiveTab("daily")}
        >
          Daily Summary
        </button>
        <button
          className={`flex-fill btn ${
            activeTab === "monthly" ? "CommonColor" : "btn-light"
          }`}
          onClick={() => setActiveTab("monthly")}
        >
          Monthly Summary
        </button>
      </div>

      {/* DATE / MONTH SELECTOR */}
      <div className="d-flex justify-content-center align-items-center my-3">
        <button
          className="btn btn-outline-warning CommonColor text-white rounded-circle mx-2"
          onClick={() =>
            activeTab === "daily" ? handleDayChange(-1) : handleMonthChange(-1)
          }
        >
          <FaArrowLeft />
        </button>
        <span
          className="fw-bold text-dark"
          style={{ cursor: "pointer" }}
          onClick={() => setShowPickerModal(true)}
        >
          {activeTab === "daily"
            ? getDateLabel(selectedDate)
            : formatMonthYearDisplay(selectedMonth)}
        </span>
        <button
          className="btn btn-outline-warning CommonColor text-white rounded-circle mx-2"
          onClick={() =>
            activeTab === "daily" ? handleDayChange(1) : handleMonthChange(1)
          }
        >
          <FaArrowRight />
        </button>
      </div>

      {/* SUMMARY CARDS */}
      <div className="row text-center mb-3">
        {/* Recharges */}
        <div className="col">
          <div className="border p-2 rounded">
            <div className="fw-bold">Recharges</div>
            <div className="text-success">
              {activeTab === "daily" ? dailySummary.totalCredit : monthlySummary.totalCredit} ↑
            </div>
            <div className="text-danger">
              {activeTab === "daily" ? dailySummary.totalDebit : monthlySummary.totalDebit} ↓
            </div>
          </div>
        </div>

        {/* Self */}
        <div className="col">
          <div className="border p-2 rounded">
            <div className="fw-bold">Self</div>
            <div className="text-dark">
              {activeTab === "daily" ? dailySummary.selfCount : monthlySummary.selfCount}
            </div>
            <div className="text-success">
              {activeTab === "daily" ? dailySummary.totalSelf : monthlySummary.totalSelf} ↑
            </div>
          </div>
        </div>

        {/* Admin */}
        <div className="col">
          <div className="border p-2 rounded">
            <div className="fw-bold">Admin</div>
            <div className="text-dark">
              {activeTab === "daily" ? dailySummary.adminCount : monthlySummary.adminCount}
            </div>
            <div className="text-danger">
              {activeTab === "daily" ? dailySummary.totalAdmin : monthlySummary.totalAdmin} ↓
            </div>
          </div>
        </div>

        {/* Agent */}
        <div className="col">
          <div className="border p-2 rounded">
            <div className="fw-bold">Agent</div>
            <div className="text-dark">
              {activeTab === "daily" ? dailySummary.agentCount : monthlySummary.agentCount}
            </div>
            <div className="text-danger">
              {activeTab === "daily" ? dailySummary.totalAgent : monthlySummary.totalAgent} ↓
            </div>
          </div>
        </div>
      </div>

      {/* TRANSACTION TABLE */}
      {/* TRANSACTION TABLE */}
<div className="divTblStyle">
  <div className="table-wrapper">
    <div className="table-responsive">
      <table className="tblStyle">
        <thead>
          <tr className="theadtrStyle">
            <th className="thStyle text-center">Date</th>
            <th className="thStyle text-center">Transaction ID</th>
            <th className="thStyle text-center">By</th>
            <th className="thStyle text-center">To</th>
            <th className="thStyle text-center">Amount</th>
            <th className="thStyle text-center">Type</th>
          </tr>
        </thead>

        <tbody>
          {paginatedTransactions.length > 0 ? (
            paginatedTransactions.map((txn) => {
              const getTextClass = (type) => {
                if (type === "SELF") return "text-success";
                if (type === "AGENT" || type === "ADMIN") return "text-danger";
                return "";
              };

              return (
                <tr key={txn.transaction_id}>
                  <td className="tdStyle">{txn.transaction_time}</td>
                  <td className="tdStyle">{txn.transaction_id}</td>
                  <td className="tdStyle">{txn.by_name}</td>
                  <td className="tdStyle">{txn.to_name}</td>
                  <td className={`tdStyle fw-bold ${getTextClass(txn.transaction_type)}`}>
                    ₹ {txn.amount}
                  </td>
                  <td className={`tdStyle fw-bold ${getTextClass(txn.transaction_type)}`}>
                    {txn.transaction_type}
                  </td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan="6" className="tdStyle text-center">
                No transactions found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  </div>
</div>



      {/* PAGINATION */}
      {totalPages > 1 && (
        <div className="d-flex justify-content-center mt-3">
          <nav>
            <ul className="pagination">
              <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                <button 
                  className="page-link" 
                  onClick={() => setCurrentPage(currentPage - 1)}
                  disabled={currentPage === 1}
                >
                  Previous
                </button>
              </li>
              {Array.from({ length: totalPages }, (_, i) => (
                <li
                  key={i}
                  className={`page-item ${currentPage === i + 1 ? "active" : ""}`}
                >
                  <button className="page-link" onClick={() => setCurrentPage(i + 1)}>
                    {i + 1}
                  </button>
                </li>
              ))}
              <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                <button 
                  className="page-link" 
                  onClick={() => setCurrentPage(currentPage + 1)}
                  disabled={currentPage === totalPages}
                >
                  Next
                </button>
              </li>
            </ul>
          </nav>
        </div>
      )}

      {renderDatepickerModal()}
    </div>
  );
};

export default TransactionHistory;